module.exports = __webpack_public_path__ + "static/acupun_1_lg-383c7ec0c61e732c03a54d097f4c25d8.png";